import { render, staticRenderFns } from "./_group.vue?vue&type=template&id=479600c0&"
import script from "./_group.vue?vue&type=script&lang=js&"
export * from "./_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports